<div class="container my-5 px-5 pt-5 pb-4 z-depth-1">
  <div class="row d-flex justify-content-center">
    <!--Grid column-->
    <div class="col-md-6 text-center">
      <!-- <h2 class="font-weight-bold text-success"></h2> -->

      <!-- <p class="text-muted">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Id quam sapiente
          molestiae.</p> -->
    </div>

    <!--Section: Content-->
    <section class="dark-grey-text">
      <style>
        .d-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          grid-auto-rows: 100px;
          grid-gap: 7px;
        }

        .item {
          position: relative;
        }

        .item:nth-child(1) {
          grid-column: 1 / 2;
          grid-row: 1 / 4;
        }

        .item:nth-child(2) {
          grid-column: 2;
          grid-row: 0 / 3;
        }

        .item:nth-child(3) {
          grid-column: 2;
          grid-row: 2 / 3;
        }

        .item:nth-child(4) {
          grid-column: 2;
          grid-row: 3 / 3;
        }

        .item a {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          top: 0;
          overflow: hidden;
        }

        .item img {
          height: 100%;
          width: 100%;
          object-fit: cover;
        }
      </style>

      <div class="row align-items-center">
        <div class="col-lg-6 mb-4">
          <h2 class="font-weight-normal font-weight-bold mb-4 text-success">
            Pokharia Panchayat
          </h2>
          <!-- <p class="lead text-muted">Beautifully designed by best interior designers for the best web designers</p> -->
          <p class="font-weight-normal">
            According to Census 2011 information, the location code or village
            of Pokharia is 387851. Pokharia village is in Saraskana Tahasil of
            Mayurbhanj district in Odisha, India. It is situated 5 km away from
            the Sub-district headquarters of Pokharia and 49 km away from the
            district headquarters of Baripada. As per 2009 stats, Pokharia
            village is also a Gram Panchayat. The total geographical area of the
            village is 1093 hectares. Pokharia has a total Population of 3159
            people. There are about houses in Pokharia village. As per 2019
            stats, Pokharia village comes under the Saraskana assembly &
            Baripada.
          </p>
        </div>

        <div class="col-lg-6 mb-4">
          <div id="mdb-lightbox-ui"></div>

          <div class="d-grid mdb-lightbox border-thick">
            <figure class="item">
              <a
                href="https://mdbootstrap.com/img/Photos/Horizontal/Architecture/12-col/img%20(10).jpg"
                class="z-depth-1 rounded"
                data-size="1600x1067"
              >
                <img
                  src="../../assets/WhatsApp Image 2025-05-17 at 2.47.17 AM.jpeg"
                />
              </a>
            </figure>
            <figure class="item">
              <a
                href="https://mdbootstrap.com/img/Photos/Horizontal/Architecture/12-col/img%20(11).jpg"
                class="z-depth-1 rounded"
                data-size="1600x1067"
              >
                <img
                  src="../../assets/WhatsApp Image 2025-05-17 at 3.30.27 AM.jpeg"
                />
              </a>
            </figure>
            <figure class="item">
              <a
                href="https://mdbootstrap.com/img/Photos/Horizontal/Architecture/12-col/img%20(12).jpg"
                class="z-depth-1 rounded"
                data-size="1600x1067"
              >
                <img
                  src="../../assets/WhatsApp Image 2025-05-17 at 3.30.28 AM.jpeg"
                />
              </a>
            </figure>
            <figure class="item">
              <a
                href="https://mdbootstrap.com/img/Photos/Horizontal/Architecture/12-col/img%20(13).jpg"
                class="z-depth-1 rounded"
                data-size="1600x1067"
              >
                <img
                  src="../../assets/WhatsApp Image 2025-05-17 at 3.30.29 AM (1).jpeg"
                />
              </a>
            </figure>
          </div>
        </div>
      </div>
    </section>

    <!--Section: Content-->
  </div>
</div>
